import { Target } from 'lucide-react'
import type Opportunity from '@/types/serializers/Opportunity'
import OpportunityCard from '@/components/OpportunityCard'

interface OpportunitiesGridProps {
  opportunities: Opportunity[]
  onOpportunityClick: (id: number) => void
  searchTerm?: string
  emptyStateMessage?: string
}

export default function OpportunitiesGrid({ 
  opportunities, 
  onOpportunityClick, 
  searchTerm = '', 
  emptyStateMessage 
}: OpportunitiesGridProps) {
  if (opportunities.length > 0) {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {opportunities.map((opportunity) => (
          <OpportunityCard 
            key={opportunity.id} 
            opportunity={opportunity}
            onClick={onOpportunityClick}
          />
        ))}
      </div>
    )
  }

  return (
    <div className="text-center py-12">
      <Target className="w-12 h-12 text-slate-300 dark:text-slate-600 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-slate-900 dark:text-white mb-2">
        {searchTerm ? 'No opportunities found' : 'No opportunities yet'}
      </h3>
      <p className="text-slate-500 dark:text-slate-400">
        {searchTerm 
          ? 'Try adjusting your search criteria or filters.'
          : (emptyStateMessage || 'Index will appear here as they are discovered.')
        }
      </p>
    </div>
  )
}